import { DayEnum, TimePeriodEnum } from '../types/providers'

// TODO ask if we need to increase this
export const NEXT_AVAILABILITY_LOOKUP_DAYS = 14

export const DAY_MAP = [
  DayEnum.SUNDAY,
  DayEnum.MONDAY,
  DayEnum.TUESDAY,
  DayEnum.WEDNESDAY,
  DayEnum.THURSDAY,
  DayEnum.FRIDAY,
  DayEnum.SATURDAY
]

export const TIME_SLOT_START_END_MAP: Record<
  TimePeriodEnum,
  { start: number; end: number }
> = {
  [TimePeriodEnum.EARLY_MORNING]: {
    start: 0,
    end: 10
  },
  [TimePeriodEnum.MORNING]: {
    start: 10,
    end: 12
  },
  [TimePeriodEnum.AFTERNOON]: {
    start: 12,
    end: 17
  },
  [TimePeriodEnum.EVENING]: {
    start: 17,
    end: 24
  }
}
